export default {"src":"/_next/static/media/calendarOne_64.b20d5d1b.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};